var map = {
	"./advancedQueryCancel.svg": "e8bc",
	"./advancedQueryDelete.svg": "1668",
	"./advancedQueryEdit.svg": "e188",
	"./advancedQuerySave.svg": "178a",
	"./img100059.svg": "49ad",
	"./img100068.svg": "3ea4",
	"./imgChanges3.svg": "4680",
	"./postSystem.svg": "7e8d",
	"./right.svg": "9a71"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "51ff";